module.exports = __webpack_public_path__ + "media/gai02.c311221b.mp3";